import gql from 'graphql-tag';
import {
	listResourceQueryDefinitions,
	viewResourceQueryDefinitions,
	createResourceMutationDefinitions,
	updateResourceMutationDefinitions,
	deleteResourceMutationDefinitions
} from '@/providers/graphql/resourceQueryDefinitions';

export const CAMPAIGNS_LIST_QUERY = gql`
	query Campaigns($first: Int, $after: String) {
		campaigns(first: $first, after: $after) {
			nodes {
				campaignId
				name
				description
				startDate
				endDate
				isActive
			}
			pageInfo {
				hasNextPage
				endCursor
			}
		}
	}
`;

export const CAMPAIGN_LIST_ITEM_QUERY = gql`
	query CampaignListItem($id: Ulid!) {
		campaign(campaignId: $id) {
			campaignId
			name
			description
			startDate
			endDate
			isActive
		}
	}
`;

export const CAMPAIGN_QUERY = gql`
	query Campaign($id: Ulid!) {
		campaign(campaignId: $id) {
			campaignId
			name
			description
			startDate
			endDate
			isActive
		}
	}
`;

export const CAMPAIGN_CREATE_MUTATION = gql`
	mutation CreateCampaign($input: CreateCampaignInput!) {
		createCampaign(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;

export const CAMPAIGN_UPDATE_MUTATION = gql`
	mutation UpdateCampaign($input: UpdateCampaignInput!) {
		updateCampaign(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;

export const CAMPAIGN_DELETE_MUTATION = gql`
	mutation DeleteCampaign($input: DeleteCampaignInput!) {
		deleteCampaign(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;

export const CAMPAIGNS_AUTOCOMPLETE_QUERY = gql`
	query CampaignsAutocomplete(
		$where: CampaignViewModelFilterInput
		$first: Int
		$after: String
	) {
		campaigns(where: $where, first: $first, after: $after) {
			edges {
				node {
					campaignId
					name
					description
					isActive
				}
			}
			pageInfo {
				hasNextPage
				endCursor
			}
		}
	}
`;

listResourceQueryDefinitions['campaigns'] = {
	document: CAMPAIGNS_LIST_QUERY,
	dataPath: 'campaigns.nodes'
};

viewResourceQueryDefinitions['campaigns'] = {
	document: CAMPAIGN_QUERY,
	dataPath: 'campaign'
};

createResourceMutationDefinitions['campaigns'] = {
	document: CAMPAIGN_CREATE_MUTATION,
	operation: 'createCampaign',
	getVariables: variables => ({ input: variables })
};

updateResourceMutationDefinitions['campaigns'] = {
	document: CAMPAIGN_UPDATE_MUTATION,
	operation: 'updateCampaign',
	getVariables: variables => ({ input: variables })
};

deleteResourceMutationDefinitions['campaigns'] = {
	document: CAMPAIGN_DELETE_MUTATION,
	operation: 'deleteCampaign',
	getVariables: variables => ({ input: variables })
};

